import React from "react";
import { Grid } from "@material-ui/core";
import { PropsWithChildren } from "react";

export const SideBySide = (props: PropsWithChildren<any>) => {
  if (props.children.length !== 2) {
    throw new Error("SideBySide can [currently] only be used with two children");
  }

  return (
    <Grid container={true}>
      {props.children.map((child: React.ReactNode, index: number) => (
        <Grid key={index} item={true} xs={6} sm={6} md={6} lg={6}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
};
